import { Keuzehulp } from '../keuzehulpen'

const extremeVroeggeboorte: Keuzehulp = {
  title: 'Extreme vroeggeboorte',
  basePath: '/extreme-vroeggeboorte',
  documentTitle: 'Extreme vroeggeboorte',
  routes: [
    {
      path: '',
      routeId: 'P18-001',
      nextRouteId: 'P18-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton: 'https://www.thuisarts.nl/overzicht/keuzehulpen',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen. ',
        },
        {
          title: '15 tot 20 minuten',
          description: 'Zo lang zijn de meeste mensen bezig met deze keuzehulp.',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed je aandacht erbij kunt houden.',
        },
        {
          title: 'Bekijk je antwoorden ',
          description: 'Aan het einde van de keuzehulp krijg je een overzicht van de vragen met jouw antwoorden. Je kunt deze antwoorden opslaan of printen. Je gegevens worden niet opgeslagen. Ook niet als je de keuzehulp tussendoor stopt.',
        },
      ],
    },
    {
      path: '/stap-1/als-je-baby-misschien-bij-24-of-25-weken-zwangerschap-wordt-geboren',
      routeId: 'P18-002',
      nextRouteId: 'P18-003',
      type: 'chapter',
      title: 'Als je baby misschien bij 24 of 25 weken zwangerschap wordt geboren',
      subtitle: 'Stap 1',
      description: `
        <p>Normaal duurt een zwangerschap ongeveer 40 weken. Soms begint je bevalling veel eerder. De arts probeert vaak om de geboorte uit te stellen. Soms lukt dat niet en wordt je baby bij 24 of 25 weken zwangerschap geboren.</p>
        <p>In deze stap leggen we uit wat dat betekent.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-handje.jpg`,
        alt: 'Afbeelding van een kinder hand',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-betekent-het-voor-jou-als-je-misschien-veel-te-vroeg-gaat-bevallen',
      routeId: 'P18-003',
      nextRouteId: 'P18-004',
      type: 'explanation',
      title: 'Wat betekent het voor jou als je misschien veel te vroeg gaat bevallen?',
      description: `
        <p>Normaal duurt een zwangerschap ongeveer 40 weken. Ben je tussen de 23 en 26 weken zwanger en begint je bevalling misschien? Dan ga je naar het ziekenhuis en kom je bij een arts die veel weet over zwangerschap en bevallen (gynaecoloog).</p>
        <p>De arts probeert vaak om de geboorte van je baby uit te stellen. Het is niet zeker of dit lukt. Soms kan dit niet en ga je toch bevallen. Dit wordt ook wel een extreme vroeggeboorte genoemd.</p>
        <p>%MODALLINK%.</p>
      `,
      modalLink: 'Lees meer over waarom je bevalling te vroeg begint',
      modalHeader: 'Waarom je bevalling te vroeg begint',
      modalText: `
        <div>
          <p>Je bevalling kan vanzelf veel te vroeg beginnen. Je kunt ook te vroeg moeten bevallen omdat het niet goed gaat met jou of je baby.</p>
          
          <p style="margin-bottom: 0;">
            <strong>Als je bevalling vanzelf veel te vroeg begint</strong><br />
            Je bevalling kan vanzelf veel te vroeg beginnen door 1 of meer van deze oorzaken:
          </p>
          <ul style="margin-block: 0;">
            <li>Je bent zwanger van 2 baby’s of meer baby’s.</li>
            <li>Je hebt te veel vruchtwater.</li>
            <li>Je hebt een ontsteking van je baarmoeder door bacteriën. Bijvoorbeeld omdat je vliezen zijn gebroken.</li>
            <li>Je baarmoederhals is zwak.</li>
          </ul>
          <p style="margin-top: 0;">Vaak is het niet duidelijk waardoor je bevalling te vroeg begint.</p>

          <p style="margin-bottom: 0;">
            <strong>Als het niet goed gaat met je baby</strong><br />
            Soms moet je veel te vroeg bevallen omdat het niet goed gaat met je baby. Bijvoorbeeld:
          </p>
          <ul style="margin-block: 0;">
            <li>Je baby groeit veel te langzaam.</li>
            <li>Je baby groeit helemaal niet meer.</li>
            <li>Je baby krijgt geen voeding of zuurstof meer omdat je moederkoek (placenta) loslaat.</li>
          </ul>

          <p style="margin-bottom: 0;">
            <strong>Als het niet goed gaat met jou</strong><br />
            Soms moet je te vroeg bevallen omdat het niet goed gaat met jou. Bijvoorbeeld in deze situaties:
          </p>
          <ul style="margin-block: 0;">
            <li>Je bloeddruk is te hoog.</li>
            <li>Je hebt zwangerschaps-vergiftiging of het HELLP-syndroom.</li>
            <li>Je hebt een ontsteking van je baarmoeder door bacteriën. Bijvoorbeeld omdat je vliezen zijn gebroken.</li>
          </ul>
        </div>
      `,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-1/wat-betekent-het-voor-je-baby-als-die-veel-te-vroeg-geboren-wordt',
      routeId: 'P18-004',
      nextRouteId: 'P18-005',
      type: 'explanation',
      title: 'Wat betekent het voor je baby als die veel te vroeg geboren wordt?',
      description: `
        <p>Als je baby bij 24 of 25 weken zwangerschap wordt geboren, is je baby nog heel klein en kwetsbaar. Je baby weegt minder dan een kilo en past ongeveer in je handen. Ook zijn de organen van je baby nog niet helemaal klaar. Bijvoorbeeld de longen, de hersenen en de darmen. Je baby kan nog niet helemaal zelf ademen.</p>
        <p>Je baby kan alleen blijven leven met hulp en zorg in het ziekenhuis. Als je baby blijft leven, ligt die vaak nog tot je uitgerekende datum in het ziekenhuis. Soms duurt het langer.</p>
        <p>Als je baby de vroege geboorte overleeft, heeft die kans op beperkingen. Je arts bespreekt met jou hoe groot de kans is dat je baby het overleeft en hoe groot de kans is op beperkingen. Verderop in de keuzehulp lees je hier meer over.</p>
        <p>Je kunt samen met de arts beslissen welke zorg er na de geboorte aan je baby gegeven wordt.</p>
        <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-lengte-verschil.png" alt="Afbeelding van een volgroeide bay en een vroeg geboren baby" style="width: 100%;" />
        <p>Links zie je een voorbeeld van een baby die geboren is bij 24 weken zwangerschap. <br />Rechts zie je een voorbeeld van een baby die geboren is bij 40 weken zwangerschap.</p>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-1/welke-mogelijkheden-zijn-er-als-je-baby-veel-te-vroeg-wordt-geboren',
      routeId: 'P18-005',
      nextRouteId: 'P18-006',
      type: 'explanation',
      title: 'Welke mogelijkheden zijn er als je baby veel te vroeg wordt geboren?',
      description: `
        <p>Je arts bespreekt met je wat de risico’s zijn voor je baby. Je kunt samen met de arts beslissen welke zorg je baby na de geboorte krijgt als die bij 24 of 25 weken geboren wordt. Er zijn 2 mogelijkheden.</p>
        <ul>
          <li style="margin-bottom: 1rem;">
            <strong>je laat je baby behandelen op de intensive care</strong></br>
            Je baby krijgt dan behandelingen om te blijven leven. Dit heet ook wel actieve opvang. De behandelingen kunnen vervelend en zwaar zijn voor je baby. Er is een kans dat je baby blijft leven.
          </li>
          <li>
            <strong>je neemt afscheid van je baby</strong></br>
            Je baby krijgt geen behandelingen op de intensive care. Je baby kan bij jou blijven en zal overlijden. Dit heet ook wel palliatieve zorg of comfort zorg. Je baby krijgt geen vervelende of zware behandelingen. Het is zeker dat je baby overlijdt.
          </li>
        </ul>
        <p>Soms zijn de risico’s voor je baby te groot. Bijvoorbeeld als je baby bij minder dan 24 weken zwangerschap geboren wordt of als er nog andere problemen zijn. Dan is het in Nederland meestal alleen mogelijk om afscheid te nemen van je baby.</p>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-1/hoe-neem-je-een-beslissing-over-de-zorg-voor-je-baby-als-die-veel-te-vroeg-geboren-wordt',
      routeId: 'P18-006',
      nextRouteId: 'P18-007',
      type: 'explanation',
      title:
        'Hoe neem je een beslissing over de zorg voor je baby als die veel te vroeg geboren wordt?',
      description: `
        <p>Het kan moeilijk zijn om nu over deze mogelijkheden na te denken en een beslissing te nemen. De mogelijkheden zijn heel verschillend. Er is geen goede of foute beslissing. Hoe een beslissing voelt, is voor iedereen anders. Je kiest wat voor jou, je partner of iemand anders die meedenkt, het beste voelt. En wat bij jullie past. Sommige ouders willen zelf zoveel mogelijk beslissen. Andere ouders willen graag meer advies van artsen. Allebei kan en allebei is goed.</p>
        <p>Hoe langer je baby in je buik blijft, hoe groter de kans dat je baby blijft leven. Ook wordt de kans op problemen en beperkingen voor je baby kleiner. Tot 26 weken zwangerschap kun je altijd opnieuw nadenken over wat je wilt.</p>
        <p style="margin-bottom: 0;">
          <strong>Team van artsen</strong><br />
          Een team van artsen en andere zorgmedewerkers helpt je om een beslissing te nemen die op dat moment bij je past. In het team zitten in ieder geval deze artsen:
        </p>
        <ul style="margin-top: 0;">
          <li>een arts die veel weet over problemen bij de zwangerschap (gynaecoloog of perinatoloog)</li>
          <li>een arts die veel weet over baby’s die veel te vroeg geboren zijn (kinderarts-neonatoloog)</li>
        </ul>

        <p style="margin-bottom: 0;">De artsen bespreken deze dingen met je:</p>
        <ul style="margin-top: 0;">
          <li>de risico’s en kansen voor je baby</li>
          <li>de kans dat je baby blijft leven</li>
          <li>de kans dat je baby overlijdt</li>
          <li>de beperkingen die je baby misschien kan krijgen als je kiest om je baby te laten behandelen</li>
          <li>wat voor jou belangrijk is en welke beslissing het beste bij je past</li>
        </ul>

        <p>Er is altijd een kleine kans dat je baby voor of tijdens de bevalling overlijdt, welke beslissing je ook neemt.</p>

        <p>
          <strong>Na 26 weken</strong><br />
          Als je baby wordt geboren na 26 of meer weken zwangerschap, is het meestal standaard dat je baby behandelingen op de intensive care krijgt. Je hoeft dan geen beslissing te nemen. De kans dat je baby blijft leven is groter, omdat je baby langer in je buik heeft gezeten.
        </p>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-zijn-de-risicos-voor-je-baby-als-die-veel-te-vroeg-wordt-geboren',
      routeId: 'P18-007',
      nextRouteId: 'P18-008',
      type: 'explanation',
      title: 'Wat zijn de risico’s voor je baby als die veel te vroeg wordt geboren?',
      description: `
      <p>Er zijn verschillende risico’s voor je baby. Er is bijvoorbeeld altijd een kans dat je baby overlijdt. Ook kan je baby last blijven houden van te vroeg geboren zijn. Elke situatie is anders. De artsen bespreken met je wat de risico’s voor jouw baby zijn.</p>
      <p style="margin-bottom: 0;">De kans dat je baby blijft leven hangt af van deze dingen:</p>
      <ul style="margin-top: 0;">
        <li>hoeveel weken en dagen je zwanger bent</li>
        <li>hoe zwaar je baby waarschijnlijk is</li>
        <li>of het een jongetje of een meisje is</li>
        <li>of je zwanger bent van 1 baby of van meer baby’s</li>
        <li>of je bevalt in een ziekenhuis met een intensive care voor baby’s</li>
        <li>of je medicijnen krijgt die ervoor zorgen dat de organen van je baby sneller ontwikkelen</li>
      </ul>

      <p>
        <strong>Later in het leven</strong><br />
        Ook als je baby later kind of volwassene is, kan die nog last hebben van te vroeg geboren zijn.
      </p>
      <p>%MODALLINK%.</p>
    `,
      modalLink: 'Bekijk voorbeelden',
      modalHeader: 'Beperkingen die je kind kan krijgen',
      modalText: `
      <div>
        <ul style="margin-top: 0;">
          <li><a href="https://www.thuisarts.nl/longschade-bij-te-vroeg-geboren-baby" target="_blank">Schade aan de longen</a>, het hart of de bloedvaten</li>
          <li>Minder goed groeien</li>
          <li>Minder goed kunnen leren</li>
          <li>Minder goed kunnen bewegen</li>
          <li><a href="https://www.thuisarts.nl/oogafwijking-bij-te-vroeg-geboren-baby" target="_blank">Minder goed zien</a> of blind zijn</li>
          <li>Minder goed kunnen horen of doof zijn</li>
          <li>Minder goed kunnen leren en denken</li>
          <li>Problemen met gedrag</li>
          <li>Minder makkelijk contact maken met andere mensen</li>
          <li>Minder goed kunnen omgaan met licht, geluid en drukte (prikkels)</li>
        </ul>
        <p>Je arts kan je hier meer over vertellen.</p>
      </div>
    `,
      align: 'left',
      titleAlign: 'left',
      button: 'Volgende',
    },
    {
      path: '/stap-2/je-baby-laten-behandelen-op-de-intensive-care',
      routeId: 'P18-008',
      nextRouteId: 'P18-009',
      type: 'chapter',
      title: 'Je baby laten behandelen op de intensive care',
      subtitle: 'Stap 2',
      description: `
        <p>Je kunt ervoor kiezen om je baby te laten behandelen op de intensive care. Je baby krijgt dan behandelingen om te kunnen blijven leven. Dit heet ook wel actieve opvang.</p>
        <p>In deze stap leggen we uit wat dat betekent.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-handje.jpg`,
        alt: 'Afbeelding van een kinder hand',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-gebeurt-er-voor-de-geboorte-als-je-beslist-om-je-baby-te-laten-behandelen',
      routeId: 'P18-009',
      nextRouteId: 'P18-010',
      type: 'explanation',
      title: 'Wat gebeurt er voor de geboorte als je beslist om je baby te laten behandelen?',
      description: `
        <p>Je bent meestal in een ziekenhuis waar artsen veel ervaring hebben met te vroeg geboren baby's. Je krijgt soms medicijnen die de weeën tegenhouden (weeën-remmers).</p>
        <h2>Medicijnen voor de organen van je baby</h2>
        <p>Je kunt medicijnen krijgen waardoor de longen van je baby zich sneller ontwikkelen. Je krijgt deze medicijnen met 2 prikken in je bil of bovenbeen. De tweede prik krijg je 24 uur na de eerste prik. De medicijnen in deze prikken heten corticosteroïden. De prikken worden soms ook wel longrijpings-prikken genoemd. Deze medicijnen werken het beste als je baby 2 tot 7 dagen na de eerste prik wordt geboren.</p>
        <p>Je krijgt ook een medicijn om de hersenen van je baby beter te beschermen. Dit medicijn heet magnesiumsulfaat. Je krijgt dit medicijn via een slangetje in je bloedvat. Dit heet een infuus.</p>
        <h2>Hoe je bevalt</h2>
        <p>Samen met je arts bespreek je hoe je gaat bevallen. Dit kan via je vagina. Dat heet een natuurlijke bevalling. Het kan ook met een keizersnede. Je arts bespreekt met je wat in jouw situatie het beste is. Ook bespreekt je arts of de hartslag van je baby wordt gecontroleerd met een hartfilmpje (CTG).</p>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-gebeurt-er-na-de-geboorte-als-je-beslist-om-je-baby-te-laten-behandelen',
      routeId: 'P18-010',
      nextRouteId: 'P18-011',
      type: 'explanation',
      title: 'Wat gebeurt er na de geboorte als je beslist om je baby te laten behandelen?',
      description: `
        <p>Er staat een team van specialisten klaar om je baby direct na de geboorte te helpen. Dit kan in de kamer waar je bevalt, of in een andere kamer. Soms gebeurt het op een speciale tafel naast jou. Je baby zit dan nog aan je vast met de navelstreng tijdens de eerste behandelingen. Als je baby in een andere kamer geholpen wordt, zit die niet meer met de navelstreng aan jou vast.</p>
        <h2>Wat doet het team?</h2>
        <p>Het team legt je baby in een plastic folie, zodat je baby warm blijft. Je baby krijgt ook meteen hulp bij het ademen. Dat is de belangrijkste hulp die je baby nodig heeft. Heel soms lukt het het hart van je baby niet om het bloed goed door het lichaam te pompen. Je baby is bij 24 of 25 weken nog te kwetsbaar om daar hulp bij te krijgen (hartmassage).</p>
        <p>Je ziet je baby even kort. Daarna gaat je baby naar de afdeling intensive care voor te vroeg geboren baby's. Deze afdeling heet de neonatale intensive care unit (NICU). De andere ouder of een familielid mag meteen met je baby mee. Jij komt zo snel mogelijk. Je ziet je baby even kort.</p>
        <p>%MODALLINK%.</p>
      `,
      modalLink:
        'Bekijk een voorbeeld van hoe het eruit kan zien als een baby in een plastic folie ligt net na de geboorte',
      modalHeader: 'Een baby in een plastic folie net na de geboorte',
      modalText: `
        <div>
          <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-2-baby-in-plastic-folie.jpg" alt="Afbeelding van een baby in een plastic folie net na de geboorte" style="width: 100%;" />
        </div>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/hoe-wordt-je-baby-verzorgd-op-de-intensive-care-nicu',
      routeId: 'P18-011',
      nextRouteId: 'P18-012',
      type: 'explanation',
      title: 'Hoe wordt je baby verzorgd op de intensive care (NICU)?',
      description: `
        <p>Je baby ligt in een speciaal babybedje. Dit heet een couveuse. In de couveuse wordt de situatie in de baarmoeder zo goed mogelijk nagemaakt. Het is er warm en geluiden blijven zoveel mogelijk buiten de couveuse. Vaak ligt er een doek of kleed over de couveuse, zodat je baby geen last heeft van fel licht. In de couveuse zitten deurtjes waar je je armen doorheen kunt doen. Zo kun je je baby aanraken en verzorgen.</p>
        <p>Op deze intensive care voor baby's zorgt een team van artsen, verpleegkundigen en andere zorgverleners voor jouw baby. Dit doen ze goed en met veel aandacht. Ook zorgen ze ervoor dat je baby zich zo prettig mogelijk voelt.</p>
        <p>Je ziet misschien veel slangetjes en draadjes bij je baby. Die zijn aangesloten op apparaten en schermen. Deze apparaten helpen je baby. De schermen helpen artsen en verpleegkundigen om te zien hoe het met je baby gaat.</p>
        <h2>Buidelen</h2>
        <p>Vaak kun je je baby op je blote huid leggen. Je baby ligt dan tegen je borst aan met warme doeken eromheen. Dit heet buidelen of huid-op-huid. Buidelen is meestal rustgevend voor je baby en voor jou. Je baby herkent je stem en ruikt je geur, waardoor die zich veilig voelt en vaak minder stress heeft.</p>
        <h2>Foto's</h2>
        <p>%COUVEUSE%. Je ziet ook de troostende hand van een ouder die de baby verzorgt.</p>
        <p>%BUIDELEN%. Je ziet een baby die hulp krijgt bij het ademen en bij een ouder op de huid ligt.</p>
      `,
      modalLinks: [
        {
          key: 'COUVEUSE',
          title: 'Een baby in de couveuse',
          link: 'Bekijk een voorbeeld van hoe het eruit kan zien als een baby in de couveuse ligt',
          content: `
            <div>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-3-modal-baby-in-couveuse-afbeelding-1.jpg" alt="Afbeelding van een baby in de couveuse" style="width: 100%;" />
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-3-modal-baby-in-couveuse-afbeelding-2.jpg" alt="Afbeelding van een baby in de couveuse" style="width: 100%;" />
            </div>
          `,
        },
        {
          key: 'BUIDELEN',
          title: 'Buidelen met een baby',
          link: 'Bekijk een voorbeeld van hoe buidelen eruit kan zien',
          content: `
            <div>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-3-buidelen-met-baby.jpg" alt="Afbeelding van een baby in een buidel" style="width: 100%;" />
            </div>
          `,
        },
      ],
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/welke-behandelingen-kan-je-baby-krijgen-op-de-intensive-care-nicu',
      routeId: 'P18-012',
      nextRouteId: 'P18-013',
      type: 'explanation',
      title: 'Welke behandelingen kan je baby krijgen op de intensive care (NICU)?',
      description: `
        <p>Je baby krijgt behandelingen om te kunnen blijven leven. Deze behandelingen kunnen vervelend of zwaar zijn voor je baby. Het is niet zeker dat je baby blijft leven.</p>
        <h2>Behandelingen op de intensive care</h2>
        <p>Als je baby te vroeg wordt geboren, heeft je baby vaak extra hulp nodig. Alle baby's krijgen hulp om makkelijker te ademen. Dit kan op verschillende manieren. Soms met een neuskapje, soms met een buisje in de luchtpijp. Omdat je baby nog niet goed zelf kan drinken, krijgt je baby eerst voeding via een slangetje in een bloedvat (infuus). Later krijgt je baby melk via een dun slangetje naar de maag (maagsonde).</p>
        <h2>Controles op de intensive care</h2>
        <p>Je baby wordt goed gecontroleerd. Er zitten plakkers op het lichaam van je baby. Die plakkers controleren de hartslag van je baby en hoeveel zuurstof er in het bloed zit. Ook krijgt je baby regelmatig bloedonderzoek om te controleren hoe het met je baby gaat.<br />Soms wordt er een echo van de hersenen van je baby gemaakt om te kijken of de hersenen zich goed ontwikkelen.</p>
        <p>Je baby blijft eerst op de intensive care. Daarna gaat je baby vaak naar een ander ziekenhuis. In totaal duurt het vaak een aantal maanden voordat je baby groot en sterk genoeg is om naar huis te kunnen.</p>
        <p>%MODALLINK%.</p>
        <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-4-intensive-care-overzicht.jpg" alt="Overzicht van een baby op de intensive care met benoemde slangetjes en apparaten" style="width: 100%;" />
        <p>Je baby kan deze slangetjes, draadjes en apparaten nodig hebben in de couveuse.</p>
      `,
      modalLink: 'Lees meer over de controles en behandelingen op de intensive care',
      modalHeader: 'Controles en behandelingen op de intensive care',
      modalText: `
        <div>
          <p style="margin-bottom: 0;"><strong>Hulp bij het ademen</strong></p>
          <p style="margin-top: 0;">Je baby kan een neuskapje, een slangetje in de neus of een buisje in de luchtpijp krijgen. Dit helpt je baby om makkelijker te ademen. Soms krijgt je baby extra zuurstof. Ook kan je baby het medicijn surfactant krijgen. Dit zorgt ervoor dat de longblaasjes makkelijker opengaan. Zo kan je baby makkelijker ademen. Je baby krijgt dit medicijn via het buisje in de luchtpijp. Je baby krijgt ook een medicijn om beter door te ademen. Dit heet coffeïne.</p>

          <p style="margin-bottom: 0;"><strong>Een dun slangetje in een bloedvat (infuus)</strong></p>
          <p style="margin-top: 0;">Via dit slangetje krijgt je baby medicijnen. Het infuus kan in de arm, het been of het hoofd van je baby zitten. De eerste dagen kan het infuus ook in een bloedvat via de navel zitten. In het begin kan je baby ook voeding krijgen via dit slangetje in een bloedvat.</p>

          <p style="margin-bottom: 0;"><strong>Een dun slangetje naar de maag (maagsonde)</strong></p>
          <p style="margin-top: 0;">Je baby kan nog niet zelf drinken. Daarom krijgt je baby een slangetje dat via de neus of de mond naar de maag gaat. Dit heet een maagsonde. Via dit slangetje krijgt je baby melk.<br />Als moeder kun je kolven. Hierbij haalt een apparaat melk uit je borsten. Soms wordt er donormelk gebruikt. Dat is moedermelk van de moedermelkbank. De melk wordt via het slangetje aan je baby gegeven.</p>

          <p style="margin-bottom: 0;"><strong>Plakkers op de borst en een bandje om de pols</strong></p>
          <p style="margin-top: 0;">Je baby krijgt een speciaal bandje om de pols of de voet (saturatiemeter). Het bandje meet hoeveel zuurstof er in het bloed zit van je baby. Het bandje is verbonden met een beeldscherm naast de couveuse. Later krijgt je baby ook 3 plakkers op de borst. Deze plakkers (ECG-plakkers) meten de hartslag en de ademhaling. Dit helpt artsen en verpleegkundigen om te zien hoe het met je baby gaat.</p>

          <p style="margin-bottom: 0;"><strong>Onderzoek van het bloed</strong></p>
          <p style="margin-top: 0;">Meestal krijgt je baby hiervoor een prik in de hiel. Soms gebeurt het via een prik of een slangetje in een bloedvat.</p>

          <p style="margin-bottom: 0;"><strong>Echo van de hersenen</strong></p>
          <p style="margin-top: 0;">Met een echo-apparaat kan de arts de hersenen van je baby bekijken. Zo kan de arts zien hoe de hersenen zich ontwikkelen. De artsen kijken bijvoorbeeld of er misschien een bloeding is.</p>

          <p>Artsen en verpleegkundigen leggen ook alles aan je uit. Ook kun je op <a href="https://www.care4neo.nl/neonatologie?formdata%5BisSubmitted_postListFilter%5D=filter_4195&return_uri=%2Fcouveuseouders&formdata%5Bfilter_4195%5D=3976" target="_blank">Care4Neo</a> meer informatie vinden.</p>
        </div>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/welke-problemen-kan-je-baby-krijgen-op-de-intensive-care-nicu',
      routeId: 'P18-013',
      nextRouteId: 'P18-014',
      type: 'explanation',
      title: 'Welke problemen kan je baby krijgen op de intensive care (NICU?)',
      description: `
        <p style="margin-bottom: 0;">Als je baby te vroeg geboren is, is je baby kwetsbaar en kan je baby problemen krijgen. Artsen weten van tevoren niet of dit gebeurt.<br />Je baby kan bijvoorbeeld deze problemen krijgen:</p>
        <ul style="margin-top: 0;">
          <li>een bloeding in de hersenen</li>
          <li>een ontsteking door een bacterie (infectie)</li>
          <li>problemen met de darmen, het hart of de longen</li>
        </ul>
        <p>Artsen en verpleegkundigen doen er alles aan om je baby zo goed mogelijk te helpen.</p>
        <h2>Hoe het kan gaan met je baby</h2>
        <p>De artsen bespreken vaak met je hoe het met je baby gaat. Soms gaat het goed. Soms krijgt je baby toch ernstige problemen. Het kan dan ook gebeuren dat je baby overlijdt, ondanks de behandelingen.</p>
        <p>Soms zijn de zorgen over de toekomst van je baby heel groot. Dan denken de artsen opnieuw na of behandelingen op de intensive care nog steeds het beste zijn voor je baby. Soms beslissen de artsen of jij samen met hen, om de behandelingen alsnog te stoppen en afscheid te nemen van je baby.</p>
        <p>Als je baby blijft leven, kan die later in het leven nog beperkingen hebben. In stap 4 lees je hier meer over.</p>
        <p>Ook al zijn er risico's, het is goed om te weten dat veel baby's op de intensive care goed geholpen kunnen worden.</p>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/hoe-groot-is-de-kans-dat-je-baby-blijft-leven-als-je-kiest-voor-behandeling-op-de-intensive-care',
      routeId: 'P18-014',
      nextRouteId: 'P18-015',
      type: 'popupCards',
      title:
        'Hoe groot is de kans dat je baby blijft leven als je kiest voor behandeling op de intensive care?',
      description: `
        <p>Hoe groot de kans is dat je baby blijft leven, hangt van veel dingen af. Bijvoorbeeld bij hoeveel weken zwangerschap je baby geboren wordt. Hieronder zie je hoe groot die kans ongeveer is.</p>
        <p>Let op: dit gaat over een grote groep baby's. Bij jouw baby kan het anders zijn. Bijvoorbeeld als je baby niet goed groeit. Als je zwanger bent van meer dan 1 baby zijn de risico's ook hoger.<br />Je arts bespreekt met jou de situatie van jouw baby.</p>
      `,
      cards: [
        {
          cardTitle: 'Als je baby bij 24 weken wordt geboren',
          readingTime:
            'Bekijk hoe groot de kans is dat je baby blijft leven als die bij 24 weken wordt geboren.',
          modalContent: `
            <div>
              <p>Alle poppetjes samen zijn 100 baby’s. Dit zijn baby’s die bij 24 weken zwangerschap zijn geboren en die op de intensive care behandelingen krijgen.</p>
              <p>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-green.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 50 van de 100 baby’s blijven leven.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-red.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 50 van de 100 baby’s overlijden.</span>
              </p>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-6-baby-bij-24-weken-infografic.jpg" alt="Infografic van baby's die bij 24 weken zwangerschap zijn geboren en die op de intensive care behandelingen krijgen" style="width: 100%;" />
            </div>
          `,
        },
        {
          cardTitle: 'Als je baby bij 25 weken wordt geboren',
          readingTime:
            'Bekijk hoe groot de kans is dat je baby blijft leven als die bij 25 weken wordt geboren.',
          modalContent: `
            <div>
              <p>Alle poppetjes samen zijn 100 baby’s. Dit zijn baby’s die bij 25 weken zwangerschap zijn geboren en die op de intensive care behandelingen krijgen.</p>
              <p>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-green.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 71 van de 100 baby’s blijven leven.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-red.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 29 van de 100 baby’s overlijden.</span>
              </p>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-6-baby-bij-25-weken-infografic.jpg" alt="Infografic van baby's die bij 25 weken zwangerschap zijn geboren en die op de intensive care behandelingen krijgen" style="width: 100%;" />
            </div>
          `,
        },
        {
          cardTitle: 'Als je baby bij 26 weken wordt geboren',
          readingTime:
            'Bekijk hoe groot de kans is dat je baby blijft leven als die bij 26 weken wordt geboren.',
          modalContent: `
            <div>
              <p>Alle poppetjes samen zijn 100 baby’s. Dit zijn baby’s die bij 26 weken zwangerschap zijn geboren en die op de intensive care behandelingen krijgen.</p>
              <p>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-green.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 84 van de 100 baby’s blijven leven.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-red.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 16 van de 100 baby’s overlijden.</span>
              </p>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap2-6-baby-bij-26-weken-infografic.jpg" alt="Infografic van baby's die bij 26 weken zwangerschap zijn geboren en die op de intensive care behandelingen krijgen" style="width: 100%;" />
            </div>
          `,
        },
      ],
      align: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/hoe-gaat-het-verder-als-je-kiest-om-je-baby-te-laten-behandelen-op-de-intensive-care',
      routeId: 'P18-015',
      nextRouteId: 'P18-016',
      type: 'explanation',
      title: 'Hoe gaat het verder als je kiest om je baby te laten behandelen op de intensive care?',
      description: `
        <h2>Veel in het ziekenhuis</h2>
        <p>Je baby blijft de eerste maanden na de geboorte in het ziekenhuis. Dat betekent dat je zelf ook veel in het ziekenhuis bent. Vaak kun je in het Ronald McDonald Huis slapen als je dat wilt. Zo hoef je weinig te reizen. Ook de rest van je gezin kan daar slapen. In sommige ziekenhuizen kun je bij je baby op de afdeling slapen.</p>
        <h2>Moeilijke tijd</h2>
        <p>Deze periode kan zwaar zijn voor je baby, voor jou, je partner en je gezin. Het kan helpen om erover te praten met iemand die je goed kent. Je kunt ook praten met een psycholoog, maatschappelijk werker of een rouwcoach.</p>
        <h2>Meer informatie</h2>
        <p>Meer informatie en contact met andere ouders van wie hun baby te vroeg geboren is: <a href="https://www.care4neo.nl/" target="_blank">Care4Neo</a>.</p>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-is-voor-jou-belangrijk-als-je-zou-beslissen-om-je-baby-te-laten-behandelen-op-de-intensive-care',
      routeId: 'P18-016',
      nextRouteId: 'P18-017',
      type: 'question',
      title: 'Wat is voor jou belangrijk als je zou beslissen om je baby te laten behandelen op de intensive care?',
      subtitle: 'Vraag',
      titleAlign: 'left',
      questions: [
        {
          placeholder: 'Je mag hier je antwoord invullen.',
          type: 'textarea',
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/afscheid-nemen-van-je-baby',
      routeId: 'P18-017',
      nextRouteId: 'P18-018',
      type: 'chapter',
      title: 'Afscheid nemen van je baby',
      subtitle: 'Stap 3',
      description: `
        <p>Je kunt ook kiezen om je baby niet te laten behandelen op de intensive care. Dit betekent dat je afscheid neemt van je baby. Je baby zal dan na de geboorte overlijden. Dit heet ook wel palliatieve zorg of comfort zorg.</p>
        <p>In deze stap leggen we uit wat dat betekent.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-handje.jpg`,
        alt: 'Afbeelding van een kinder hand',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-beval-je-als-je-beslist-om-afscheid-te-nemen-van-je-baby',
      routeId: 'P18-018',
      nextRouteId: 'P18-019',
      type: 'explanation',
      title: 'Hoe beval je als je beslist om afscheid te nemen van je baby?',
      description: `
        <p>Je arts bespreekt met je hoe je gaat bevallen. Meestal beval je via je vagina (natuurlijke bevalling). Heel soms is een keizersnede nodig, bijvoorbeeld als dat beter is voor jou.</p>
        <p>Soms krijg je medicijnen om de weeën tegen te houden (weeën-remmers). Artsen proberen zo de geboorte uit te stellen. Je kunt dan nog medicijnen krijgen waardoor de longen van je baby zich sneller ontwikkelen. Als je zwangerschap 26 weken of langer duurt, krijgt je baby meestal standaard behandelingen op de intensive care. Dan is de situatie anders.</p>
        <p>De beslissing om afscheid te nemen, geldt dus alleen als je baby wel bij 24 of 25 weken geboren wordt.</p>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/wat-gebeurt-er-na-de-geboorte-als-je-afscheid-neemt-van-je-baby',
      routeId: 'P18-019',
      nextRouteId: 'P18-020',
      type: 'explanation',
      title: 'Wat gebeurt er na de geboorte als je afscheid neemt van je baby?',
      description: `
        <p>Na de geboorte blijft je baby bij jou, zodat je zoveel mogelijk tijd met je baby hebt. Een verpleegkundige legt je baby in je armen. Daarna krijgt je baby warme doeken of een dekentje om zich heen. Zo blijft je baby lekker warm en voelt je baby zich prettig. Je blijft met je baby in een rustige ruimte. Je baby heeft meestal geen pijn en lijdt niet. Als artsen toch denken dat je baby pijn heeft, krijgt je baby pijnstilling. Ook helpen artsen en zorgmedewerkers jou bij het afscheid nemen van je baby.</p>
        <p>Je baby zal bij jou overlijden. Je baby krijgt dus geen behandelingen en gaat niet naar de afdeling intensive care. Soms overlijdt je baby na een paar minuten, soms na een paar uur. Daarna helpen verpleegkundigen je om je baby te wassen, te verzorgen en aan te kleden. Je kunt tegen verpleegkundigen zeggen welke hulp en zorg je daarbij prettig vindt.</p>
        <h2>Andere mensen of je kinderen</h2>
        <p>Als je wilt, mogen ook andere mensen bij je zijn. Als je al kinderen hebt, kunnen verpleegkundigen je kinderen betrekken bij het afscheid. Ze kunnen bijvoorbeeld samen met de kinderen foto's maken. Ze kunnen ook helpen om je kinderen uit te leggen wat er gebeurt.</p>
        <h2>Herinneringen maken</h2>
        <p>Verpleegkundigen en artsen kunnen je helpen om herinneringen te maken. Ze maken bijvoorbeeld foto's, of knippen een plukje haar af om te bewaren. Ze kunnen ook afdrukjes maken van de handjes en voetjes van je baby.</p>
        <h2>Meer informatie</h2>
        <p>Meer informatie en contact met andere ouders die afscheid hebben genomen van hun baby: <a href="https://www.stillelevens.nl/" target="_blank">Stille Levens</a>.</p>
        <img src="${process.env.PUBLIC_URL}/img/Vroeggeboorte-stap3-2-voet-vergelijking.jpg" alt="Vergelijking van de voetafdrukjes van een te vroeg geboren baby naast een munt van 1 euro" style="width: 100%;" />
        <p>De voetafdrukjes van je baby zijn iets groter dan een munt van 1 euro.</p>
        <h2>Foto's</h2>
        <ul>
          <li>%FOTO_OUDERS%.</li>
          <li>%FOTO_HANDJE%.</li>
        </ul>
      `,
      modalLinks: [
        {
          key: 'FOTO_OUDERS',
          title: 'Een overleden baby in de handen van de ouders',
          link: 'Je kunt een foto zien van een overleden baby in de handen van de ouders',
          content: `
            <div>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap3-2-modal-overleden-baby.jpg" alt="Foto van een overleden baby in de handen van de ouders" style="width: 100%;" />
            </div>
          `,
        },
        {
          key: 'FOTO_HANDJE',
          title: 'Het handje van een overleden baby in de handen van de ouders',
          link: 'Je kunt een foto zien van het handje van een overleden baby in de handen van de ouders',
          content: `
            <div>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap3-2-modal-overleden-baby-hand.jpg" alt="Foto van een overleden baby hand" style="width: 100%;" />
            </div>
          `,
        },
      ],
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-3/wat-is-voor-jou-belangrijk-als-je-afscheid-van-je-baby-zou-nemen',
      routeId: 'P18-020',
      nextRouteId: 'P18-021',
      type: 'question',
      title: 'Wat is voor jou belangrijk als je afscheid van je baby zou nemen?',
      subtitle: 'Vraag',
      titleAlign: 'left',
      questions: [
        {
          placeholder: 'Je mag hier je antwoord invullen.',
          type: 'textarea',
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-4/hoe-kan-de-toekomst-van-je-kind-eruit-zien-als-je-kiest-voor-behandeling-op-de-intensive-care',
      routeId: 'P18-021',
      nextRouteId: 'P18-022',
      type: 'chapter',
      title: 'Hoe kan de toekomst van je kind eruit zien als je kiest voor behandeling op de intensive care?',
      subtitle: 'Stap 4',
      description: `
        <p>Als je baby veel te vroeg geboren wordt, kun je je zorgen maken over de toekomst van je baby. Dat is heel begrijpelijk. Kinderen die te vroeg geboren worden en blijven leven, hebben namelijk meer kans op beperkingen later.</p>
        <p>In deze stap leggen we uit welke beperkingen je kind later kan krijgen.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-handje.jpg`,
        alt: 'Afbeelding van een kinder hand',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/welke-beperkingen-kan-je-kind-later-misschien-krijgen',
      routeId: 'P18-022',
      nextRouteId: 'P18-023',
      type: 'explanation',
      title: 'Welke beperkingen kan je kind later misschien krijgen?',
      description: `
        <p>Kinderen die te vroeg geboren zijn, hebben meer kans om later beperkingen te krijgen. Soms hebben kinderen een combinatie van beperkingen. En hebben ze hun hele leven zorg nodig. Het kan ook zijn dat je kind helemaal geen beperkingen krijgt. Dit verschilt per kind.</p>
        <p>Artsen weten van tevoren niet zeker of je kind beperkingen krijgt. En als je kind beperkingen krijgt, weten ze niet precies welke beperkingen dat zullen zijn. Ook weten ze niet precies hoe erg die beperkingen zijn.</p>
        <p style="margin-bottom: 0;">Dit zijn voorbeelden van beperkingen die je kind later kan krijgen:</p>
        <ul style="margin-top: 0;">
          <li><a href="https://www.thuisarts.nl/longschade-bij-te-vroeg-geboren-baby" target="_blank">Schade aan de longen</a>, het hart of de bloedvaten</li>
          <li>Minder goed groeien</li>
          <li>Minder goed kunnen bewegen</li>
          <li><a href="https://www.thuisarts.nl/oogafwijking-bij-te-vroeg-geboren-baby" target="_blank">Minder goed zien</a> of blind zijn</li>
          <li>Minder goed kunnen horen of doof zijn</li>
          <li>Minder goed kunnen leren en denken</li>
          <li>Problemen met gedrag</li>
          <li>Minder makkelijk contact maken met andere mensen</li>
          <li>Minder goed kunnen omgaan met licht, geluid en drukte (prikkels)</li>
        </ul>
      `,
      align: 'left',
      titleAlign: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-4/soorten-beperkingen-bij-je-kind',
      routeId: 'P18-023',
      nextRouteId: 'P18-024',
      type: 'popupCards',
      title: 'Soorten beperkingen bij je kind',
      description: `
        <p>Je kind kan misschien lichte, matige en ernstige beperkingen hebben. Maar dat hoeft niet. Sommige kinderen hebben geen beperkingen.</p>
        <p>Over sommige beperkingen later in het leven zijn cijfers bekend, maar niet over alles.<br />Hieronder staan cijfers van bepaalde lichte, matige en ernstige beperkingen. Ook lees je wat dit kan betekenen voor het leven van je kind. Zo kun je beter begrijpen wat je misschien kunt verwachten.</p>
        <h2>Belangrijk om te weten</h2>
        <ul>
          <li>Het gaat hier alleen om beperkingen met bewegen, leren, zien en horen.</li>
          <li>Je kind kan ook andere problemen krijgen, bijvoorbeeld met gedrag of concentratie of omgaan met andere mensen. Die staan niet bij de cijfers hieronder.</li>
          <li>Het gaat hier over een groep kinderen. Voor jouw kind kan het anders zijn.</li>
        </ul>
        <h2>Overslaan</h2>
        <p>Je kunt deze informatie ook overslaan als je dat wilt.</p>
      `,
      cards: [
        {
          cardTitle: 'Lichte beperkingen',
          readingTime: '',
          modalContent: `
            <div>
              <p>Voorbeelden van lichte beperkingen bij bewegen, leren, zien en horen:</p>
              <ul>
                <li>Je kind loopt wiebeliger en is misschien wat langzamer. Je kind is onhandig bij spelen en sporten.</li>
                <li>Je kind leert waarschijnlijk moeilijker dan andere kinderen. Vaak heeft je kind extra hulp en uitleg nodig op school. Soms gaat je kind daarom naar een speciale basisschool. Later gaat je kind misschien naar een school waar die leert door dingen te doen. Dat heet praktijkonderwijs of vmbo-basis.</li>
                <li>Je kind heeft een bril nodig.</li>
                <li>Je kind heeft een hoortoestel nodig.</li>
              </ul>
            </div>
          `,
        },
        {
          cardTitle: 'Matige beperkingen',
          readingTime: '',
          modalContent: `
            <div>
              <p>Voorbeelden van matige beperkingen bij bewegen, leren, zien en horen:</p>
              <ul>
                <li>Je kind zit misschien in een rolstoel. Of je kind kan wel lopen, maar niet goed rennen. En heeft voor lange afstanden een looprek nodig. Je kind is onhandig bij spelen en sporten.</li>
                <li>Je kind leert veel moeilijker dan andere kinderen en heeft extra hulp en uitleg nodig op school. Vaak gaat je kind daarom naar een speciale basisschool. Later gaat je kind vaak naar een school waar die leert door dingen te doen. Dat heet praktijkonderwijs. Of naar een speciale middelbare school met extra hulp en begeleiding.</li>
                <li>Je kind ziet minder goed, ook met een bril.</li>
                <li>Je kind hoort minder goed, ook met een hoortoestel.</li>
              </ul>
            </div>
          `,
        },
        {
          cardTitle: 'Ernstige beperkingen',
          readingTime: '',
          modalContent: `
            <div>
              <p>Voorbeelden van ernstige beperkingen bij bewegen, leren, zien en horen:</p>
              <ul>
                <li>Je kind heeft veel last van stijve spieren en maakt onverwachte bewegingen. Bijvoorbeeld met een arm of een been. Dit heet ook wel spasmen of spasticiteit. Je kind kan niet zelf zitten, staan of lopen. Het heeft altijd hulpmiddelen nodig, zoals een rolstoel of een looprek.</li>
                <li>Je kind kan bijna niets leren of begrijpen en heeft altijd veel begeleiding nodig.</li>
                <li>Je kind is blind aan allebei de ogen.</li>
                <li>Je kind is doof aan allebei de oren.</li>
              </ul>
            </div>
          `,
        },
      ],
      align: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-4/hoe-groot-is-de-kans-dat-je-kind-later-beperkingen-krijgt',
      routeId: 'P18-024',
      nextRouteId: 'P18-025',
      type: 'popupCards',
      title: 'Hoe groot is de kans dat je kind later beperkingen krijgt?',
      description: `
        <p>Hier lees je wat de kans is op bepaalde beperkingen later, als je kind veel te vroeg geboren wordt en blijft leven. Ook lees je of deze beperkingen licht, matig of ernstig zijn. Dit is uitgelegd in de stap hiervoor.</p>
        <h2>Belangrijk om te weten</h2>
        <ul>
          <li>Het gaat hier alleen om beperkingen met bewegen, leren, zien en horen.</li>
          <li>Je kind kan ook andere problemen krijgen, bijvoorbeeld met gedrag of concentratie of omgaan met andere mensen. Die staan niet bij de cijfers hieronder.</li>
          <li>Het gaat hier over een groep kinderen. Voor jouw kind kan het anders zijn.</li>
        </ul>
        <h2>Hoe lees je de poppetjes?</h2>
        <p>Alle poppetjes samen zijn 100 kinderen die te vroeg geboren zijn.</p>
        <p>
          <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-green.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> Groene poppetjes: dit zijn de kinderen zonder beperkingen.</span>
          <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-yellow.svg" alt="Geel persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> Gele poppetjes: dit zijn de kinderen met lichte beperkingen.</span>
          <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-red.svg" alt="Roze persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> Roze poppetjes: dit zijn de kinderen met matige of ernstige beperkingen.</span>
        </p>
      `,
      cards: [
        {
          cardTitle: 'Als je kind bij 24 weken is geboren en blijft leven',
          readingTime: 'Bekijk de kans op beperkingen als je kind bij 24 weken is geboren.',
          modalContent: `
            <div>
              <p>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-green.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 38 van de 100 kinderen krijgen geen beperkingen.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-yellow.svg" alt="Geel persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 39 van de 100 kinderen krijgen lichte beperkingen.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-red.svg" alt="Roze persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 23 van de 100 kinderen krijgen matige of ernstige beperkingen.</span>
              </p>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap4-3-modal-24-weken-infographic.jpg" alt="Infographic van 100 kinderen die bij 24 weken zwangerschap zijn geboren en blijven leven, opgedeeld naar geen, lichte, of matige/ernstige beperkingen" style="width: 100%;" />
            </div>
          `,
        },
        {
          cardTitle: 'Als je kind bij 25 weken is geboren en blijft leven',
          readingTime: 'Bekijk de kans op beperkingen als je kind bij 25 weken is geboren',
          modalContent: `
            <div>
              <p>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-green.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 42 van de 100 kinderen krijgen geen beperkingen.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-yellow.svg" alt="Geel persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 35 van de 100 kinderen krijgen lichte beperkingen.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-red.svg" alt="Roze persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 23 van de 100 kinderen krijgen matige of ernstige beperkingen.</span>
              </p>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap4-3-modal-25-weken-infographic.jpg" alt="Infographic van 100 kinderen die bij 25 weken zwangerschap zijn geboren en blijven leven, opgedeeld naar geen, lichte, of matige/ernstige beperkingen" style="width: 100%;" />
            </div>
          `,
        },
        {
          cardTitle: 'Als je kind bij 26 weken is geboren en blijft leven',
          readingTime: 'Bekijk de kans op beperkingen als je kind bij 26 weken is geboren',
          modalContent: `
            <div>
              <p>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-green.svg" alt="Groen persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 51 van de 100 kinderen krijgen geen beperkingen.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-yellow.svg" alt="Geel persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 36 van de 100 kinderen krijgen lichte beperkingen.</span>
                <span style="display: flex;"><img src="${process.env.PUBLIC_URL}/icons/icon-person-red.svg" alt="Roze persoons icoon" style="width: 19px; margin: 0 8px 0 0;" /> 13 van de 100 kinderen krijgen matige of ernstige beperkingen.</span>
              </p>
              <img src="${process.env.PUBLIC_URL}/img/vroeggeboorte-stap4-3-modal-26-weken-infographic.jpg" alt="Infographic van 100 kinderen die bij 26 weken zwangerschap zijn geboren en blijven leven, opgedeeld naar geen, lichte, of matige/ernstige beperkingen" style="width: 100%;" />
            </div>
          `,
        },
      ],
      align: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-4/wat-zeggen-kinderen-en-gezinnen-die-het-meegemaakt-hebben-later',
      routeId: 'P18-025',
      nextRouteId: 'P18-026',
      type: 'explanation',
      title: 'Wat zeggen kinderen en gezinnen die het meegemaakt hebben later?',
      description: `
        <p>Het kan moeilijk zijn om te lezen welke beperkingen je kind later kan krijgen. Het kan ook moeilijk zijn om te bedenken wat dit kan betekenen voor het leven van je kind. Het is goed om deze positieve dingen te weten over kinderen die te vroeg geboren zijn en hun gezinnen:</p>
        <ul>
          <li style="margin-bottom: 16px;">Ouders van kinderen die te vroeg geboren zijn, hebben bijna nooit spijt van hun beslissing. Ook al was het een moeilijke beslissing. Dit geldt voor alle ouders, welke beslissing ze ook hebben genomen. Goede uitleg en begeleiding helpt ouders om een beslissing te nemen die het beste bij hun situatie past.</li>
          <li style="margin-bottom: 16px;">De meeste kinderen die te vroeg geboren zijn, vinden hun leven later als volwassene goed. Soms voelen ze zich sterk omdat ze het overleefd hebben. Ze zijn vaak tevreden en blij dat ze leven, ook al hebben ze soms beperkingen.</li>
          <li style="margin-bottom: 16px;">Veel ouders vinden hun kind gelukkig, ook als hun kind beperkingen heeft.</li>
          <li>Sommige families worden sterker. Ze kunnen beter omgaan met moeilijke dingen. Ze zijn dankbaarder en hebben een sterkere band met elkaar.</li>
        </ul>
      `,
      align: 'left',
      button: 'Ga verder',
    },
    {
      path: '/stap-5/de-mogelijkheden-naast-elkaar',
      routeId: 'P18-026',
      nextRouteId: 'P18-027',
      type: 'chapter',
      title: 'De mogelijkheden naast elkaar',
      subtitle: 'Stap 5',
      description: `
        <p>Het kan moeilijk zijn om een beslissing te nemen als je baby bij 24 of 25 weken zwangerschap wordt geboren. Het kan helpen om de mogelijkheden naast elkaar te zien. Zo kun je ze met elkaar vergelijken.</p>
        <p>In deze stap zetten we de mogelijkheden op een rij.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-handje.jpg`,
        alt: 'Afbeelding van een kinder hand',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-5/overzicht-van-de-mogelijkheden',
      routeId: 'P18-027',
      nextRouteId: 'P18-028',
      type: 'explanation',
      title: 'Overzicht van de mogelijkheden als je baby bij 24 of 25 weken zwangerschap wordt geboren',
      titleAlign: 'center',
      align: 'left',
      description: `
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Je laat je baby behandelen op de intensive care</th>
              <th>Je neemt afscheid van je baby</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat betekent het?</th>
              <td>
                <ul>
                  <li>Je baby krijgt behandelingen om te blijven leven.</li>
                  <li>Deze behandelingen kunnen vervelend of zwaar zijn.</li>
                  <li>Na de bevalling gaat je baby naar de afdeling intensive care.</li>
                  <li>Er is een kans dat je baby blijft leven. Dit is niet zeker.</li>
                  <li>Je kunt je beslissing soms nog veranderen. Als je baby ernstige problemen krijgt of als de zorgen voor de toekomst van je baby heel groot zijn, kunnen de artsen of jij samen met hen beslissen om de behandelingen alsnog te stoppen en afscheid te nemen van je baby.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Je baby krijgt geen vervelende of zware behandelingen om te blijven leven.</li>
                  <li>Na de bevalling blijft je baby bij jou.</li>
                  <li>Je baby overlijdt binnen een paar minuten tot een paar uur na de bevalling.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Hoe lang blijft je baby in het ziekenhuis?</th>
              <td>
                <ul>
                  <li>Dat is bij elke baby anders. Meestal een paar maanden.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Een paar uur. Of zolang jij nog zorg nodig hebt voor jezelf.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Hoe kan dit voor je zijn?</th>
              <td>
                <ul>
                  <li>Je bent veel in het ziekenhuis.</li>
                  <li>Het zal een zware periode zijn voor jou, je partner en je gezin.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Het zal zwaar zijn voor jou, je partner en je gezin.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Welke beperkingen kan je kind later krijgen?</th>
              <td>
                <ul>
                  <li>Je kind kan beperkingen krijgen met bijvoorbeeld bewegen, leren, horen en zien.</li>
                  <li>Deze beperkingen kunnen licht, matig of ernstig zijn.</li>
                  <li>Sommige kinderen krijgen geen beperkingen.</li>
                </ul>
              </td>
              <td>
                <ul>
                  <li>Omdat je kind overlijdt, kan het later geen beperkingen krijgen.</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-6/vragen-die-ouders-kunnen-hebben',
      routeId: 'P18-028',
      nextRouteId: 'P18-029',
      type: 'chapter',
      title: 'Vragen die ouders kunnen hebben',
      subtitle: 'Stap 6',
      description: `
        <p>Je hebt nu veel informatie gelezen. In deze stap krijg je een aantal vragen over deze informatie. Dit zijn vragen die ouders in deze situatie kunnen hebben. De vragen helpen je om de informatie goed te begrijpen en te onthouden.</p>
        <p>Je kunt de vragen ook overslaan. Klik dan op 'Ga verder'.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-handje.jpg`,
        alt: 'Afbeelding van een kinder hand',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-6/is-het-zeker-dat-je-baby-veel-te-vroeg-geboren-wordt',
      routeId: 'P18-029',
      nextRouteId: 'P18-030',
      type: 'feedbackQuestion',
      title: 'Is het zeker dat je baby veel te vroeg geboren wordt?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is nee.</h2>
            <p style="margin-top: 0;">Het is niet zeker dat je baby veel te vroeg geboren wordt. Artsen proberen vaak om de geboorte zo lang mogelijk uit te stellen. Veel mensen die misschien veel te vroeg gaan bevallen, blijven langer zwanger. De kansen voor je baby worden dan beter.</p>
          `,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Het is inderdaad niet zeker dat je baby veel te vroeg geboren wordt. Artsen proberen vaak om de geboorte zo lang mogelijk uit te stellen. Veel mensen die misschien veel te vroeg gaan bevallen, blijven langer zwanger. De kansen voor je baby worden dan beter.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-6/kan-je-baby-later-beperkingen-krijgen',
      routeId: 'P18-030',
      nextRouteId: 'P18-031',
      type: 'feedbackQuestion',
      title: 'Als je besloten hebt om je baby op de intensive care te laten behandelen en je baby blijft leven, kan je baby dan later beperkingen krijgen?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Je baby kan inderdaad later beperkingen krijgen. Dit kunnen beperkingen zijn met bijvoorbeeld bewegen, leren, horen en zien. Maar dit hoeft niet. Er zijn ook kinderen die geen beperkingen krijgen.</p>
          `,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is ja.</h2>
            <p style="margin-top: 0;">Je baby kan later beperkingen krijgen. Bijvoorbeeld beperkingen met bewegen, leren, horen en zien. Maar dit hoeft niet. Er zijn ook kinderen die geen beperkingen krijgen.</p>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-6/kan-je-baby-overlijden-op-de-intensive-care',
      routeId: 'P18-031',
      nextRouteId: 'P18-032',
      type: 'feedbackQuestion',
      title: 'Kan je baby overlijden als je beslist om je baby op de intensive care te laten behandelen?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Je baby kan helaas overlijden op de intensive care, ook als je baby behandelingen krijgt om te blijven leven.</p>
          `,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is ja.</h2>
            <p style="margin-top: 0;">Je baby kan helaas overlijden op de intensive care, ook als je baby behandelingen krijgt om te blijven leven.</p>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-6/hoe-lang-leeft-je-baby-als-je-afscheid-neemt',
      routeId: 'P18-032',
      nextRouteId: 'P18-033',
      type: 'feedbackQuestion',
      title: 'Als je kiest om afscheid te nemen van je baby, hoe lang leeft je baby dan?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Een paar dagen',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is een paar minuten of een paar uur.</h2>
            <p style="margin-top: 0;">Meestal leeft je baby een paar minuten tot een paar uur. Heel soms is je baby al overleden bij de geboorte.</p>
          `,
          correctOption: false,
        },
        {
          title: 'Een paar minuten of een paar uur',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Meestal leeft je baby een paar minuten tot een paar uur. Heel soms is je baby al overleden bij de geboorte.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-6/kun-je-je-beslissing-nog-veranderen',
      routeId: 'P18-033',
      nextRouteId: 'P18-034',
      type: 'feedbackQuestion',
      title: 'Kun je je beslissing nog veranderen voordat je baby geboren is?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Je kunt je beslissing altijd nog veranderen. Als je langer zwanger blijft, worden de kansen voor je baby beter. Je kunt dan een andere beslissing nemen. Of je mening verandert, dat kan ook. Wordt je baby na 26 weken geboren en zijn er geen grote risico's voor je baby? Dan is het meestal standaard dat je baby behandelingen op de intensive care krijgt. Je hoeft dan geen beslissing te nemen.</p>
          `,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is ja.</h2>
            <p style="margin-top: 0;">Je kunt je beslissing altijd nog veranderen. Als je langer zwanger blijft, worden de kansen voor je baby beter. Je kunt dan een andere beslissing nemen. Of je mening verandert, dat kan ook. Wordt je baby na 26 weken geboren en zijn er geen grote risico's voor je baby? Dan is het meestal standaard dat je baby behandelingen op de intensive care krijgt. Je hoeft dan geen beslissing te nemen.</p>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-6/kun-je-de-beslissing-nog-veranderen-na-de-geboorte',
      routeId: 'P18-034',
      nextRouteId: 'P18-035',
      type: 'feedbackQuestion',
      title: 'Kun je de beslissing om je baby op de intensive care te laten behandelen nog veranderen nadat je baby geboren is?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Dit is het goede antwoord. Je kunt de beslissing soms nog veranderen. Soms gaat het best goed met je baby en zijn er geen grote problemen. Soms kan je baby in de eerste tijd in het ziekenhuis toch ernstige problemen krijgen. Dan kunnen de zorgen voor de toekomst van je baby heel groot zijn. Artsen denken dan opnieuw na of behandelingen op de intensive care nog steeds het beste zijn voor je baby. Soms beslissen de artsen of jij samen met hen, om de behandelingen alsnog te stoppen en afscheid te nemen van je baby.</p>
          `,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is ja.</h2>
            <p style="margin-top: 0;">Je kunt de beslissing soms nog veranderen. Soms gaat het best goed met je baby en zijn er geen grote problemen. Soms kan je baby in de eerste tijd in het ziekenhuis toch ernstige problemen krijgen. Dan kunnen de zorgen voor de toekomst van je baby heel groot zijn. Artsen denken dan opnieuw na of behandelingen op de intensive care nog steeds het beste zijn voor je baby. Soms beslissen de artsen of jij samen met hen, om de behandelingen alsnog te stoppen en afscheid te nemen van je baby.</p>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-6/kun-je-beslissing-afscheid-nog-veranderen',
      routeId: 'P18-035',
      nextRouteId: 'P18-036',
      type: 'feedbackQuestion',
      title: 'Kun je je beslissing om afscheid te nemen van je baby nog veranderen voordat je baby geboren is?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Dit is het goede antwoord. Heb je besloten om afscheid te nemen en ben je nog niet bevallen? Dan kun je deze beslissing nog veranderen.</p>
          `,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is ja.</h2>
            <p style="margin-top: 0;">Heb je besloten om afscheid te nemen en ben je nog niet bevallen? Dan kun je deze beslissing nog veranderen.</p>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-6/kun-je-beslissing-afscheid-nog-veranderen-na-geboorte',
      routeId: 'P18-036',
      nextRouteId: 'P18-037',
      type: 'feedbackQuestion',
      title: 'Kun je je beslissing om afscheid te nemen van je baby nog veranderen nadat je baby geboren is?',
      subtitle: 'Vraag',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Het goede antwoord is nee.</h2>
            <p style="margin-top: 0;">Als je hebt besloten om afscheid te nemen en je baby is overleden, kun je je beslissing niet meer veranderen.</p>
          `,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Als je hebt besloten om afscheid te nemen en je baby is overleden, kun je je beslissing niet meer veranderen.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/wat-vind-jij-belangrijk',
      routeId: 'P18-037',
      nextRouteId: 'P18-038',
      type: 'chapter',
      title: 'Wat vind jij belangrijk?',
      subtitle: 'Stap 7',
      description: `
        <p>Je krijgt nu een paar vragen of stellingen te zien. Door hier antwoord op te geven, ontdek je wat voor jou belangrijk is.</p>
      `,
      align: 'left',
      titleAlign: 'center',
      image: {
        src: `${process.env.PUBLIC_URL}/img/vroeggeboorte-stap1-handje.jpg`,
        alt: 'Afbeelding van een kinder hand',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-7/ik-kan-accepteren-dat-mijn-kind-beperkingen-heeft',
      routeId: 'P18-038',
      nextRouteId: 'P18-039',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik denk dat ik kan accepteren dat mijn kind later in het leven beperkingen heeft',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/ik-vind-het-moeilijk-als-mijn-kind-ernstige-beperkingen-heeft',
      routeId: 'P18-039',
      nextRouteId: 'P18-040',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik vind het moeilijk voor mijn kind als die later ernstige beperkingen heeft',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/ik-kan-accepteren-dat-mijn-baby-niet-op-de-intensive-care-behandeld-wordt',
      routeId: 'P18-040',
      nextRouteId: 'P18-041',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik denk dat ik kan accepteren dat mijn baby niet op de intensive care behandeld wordt',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/ik-vind-het-moeilijk-als-mijn-baby-zware-behandelingen-krijgt',
      routeId: 'P18-041',
      nextRouteId: 'P18-042',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik vind het moeilijk voor mijn baby als die vervelende of zware behandelingen krijgt om te blijven leven',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/als-er-een-kans-is-dat-mijn-baby-blijft-leven-ga-ik-ervoor',
      routeId: 'P18-042',
      nextRouteId: 'P18-043',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Als er een kans is dat mijn baby gezond is en blijft leven, dan ga ik ervoor',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/ik-vind-het-moeilijk-om-veel-in-het-ziekenhuis-te-zijn',
      routeId: 'P18-043',
      nextRouteId: 'P18-044',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik vind het moeilijk om de periode na de geboorte veel in het ziekenhuis te zijn. Dit wil ik liever niet voor mijn baby en mijn gezin',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/wat-is-voor-jou-belangrijk-bij-het-nemen-van-een-beslissing',
      routeId: 'P18-044',
      nextRouteId: 'P18-045',
      type: 'question',
      title: 'Wat is voor jou belangrijk bij het nemen van een beslissing? En waar heb je behoefte aan?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      description: `
        <p style="margin-bottom: 0;">Je kunt bijvoorbeeld nadenken over deze vragen:</p>
        <ul style="margin-top: 0;">
          <li>Weet je zelf al wat jou het beste lijkt? Of wil je graag meer advies van je arts?</li>
          <li>Heb je een gevoel welke beslissing het beste bij je past?</li>
          <li>Heb je genoeg informatie of zijn er nog dingen die je wilt weten van je arts?</li>
          <li>Wil je nog met iemand anders praten over je beslissing?</li>
          <li>Wat is je grootste wens voor de toekomst van je kind? En als je dat hebt, je gezin?</li>
          <li>Wat is je grootste angst voor de toekomst van je kind? En als je dat hebt, je gezin?</li>
          <li>Wat zou je een goed leven voor je kind vinden?</li>
        </ul>
      `,
      questions: [
        {
          placeholder: 'Je mag hier je antwoord invullen.',
          type: 'textarea',
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/heb-je-een-idee-welke-beslissing-bij-jou-past',
      routeId: 'P18-045',
      nextRouteId: 'P18-046',
      type: 'question',
      title: 'Nu je de keuzehulp hebt gedaan: heb je een idee of gevoel welke beslissing het beste bij jou past? Als dat zo is, welke beslissing is dat dan?',
      subtitle: 'Vraag',
      questions: [
        {
          placeholder: 'Je mag hier je antwoord invullen.',
          type: 'textarea',
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/hoe-zeker-ben-je-van-je-beslissing',
      routeId: 'P18-046',
      nextRouteId: 'P18-047',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Als je misschien al weet welke beslissing je wilt nemen, hoe zeker ben je van je beslissing?',
      answers: [
        { title: 'Heel zeker' },
        { title: 'Zeker' },
        { title: 'Niet zeker, niet onzeker' },
        { title: 'Onzeker' },
        { title: 'Heel onzeker' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-7/heb-je-nog-vragen-of-is-er-iets-onduidelijk',
      routeId: 'P18-047',
      nextRouteId: 'P18-048',
      type: 'question',
      title: 'Heb je nog vragen of is er nog iets onduidelijk?',
      subtitle: 'Vraag',
      descriptionAlign: 'left',
      description: `
        <p>Vul dit dan hieronder in. Je kunt hier ook nog wat opschrijven over je gedachten en gevoelens over een beslissing. Zo heb je aan het einde van deze keuzehulp al je antwoorden, vragen en gedachten op een rij. Dit kan je helpen bij het gesprek met je arts.</p>
      `,
      questions: [
        {
          placeholder: 'Je mag hier je antwoord invullen.',
          type: 'textarea',
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/print-overview',
      routeId: 'P18-048',
      nextRouteId: 'end',
      type: 'end',
      header: {
        subtitle: 'Einde keuzehulp',
        title: 'Hier zijn je antwoorden bij deze keuzehulp',
        description: `
          <div>
            <p>Je bent nu klaar met de keuzehulp. Bespreek met je arts hoe je denkt over de mogelijkheden als je baby te vroeg wordt geboren. Bespreek ook welke beslissing het beste bij je past. Je kunt je beslissing voor de geboorte nog veranderen als je dat wilt. Vraag of je beslissing in je dossier wordt gezet.</p>
            <p>Heb je nog vragen? Kijk dan op Thuisarts bij <a href="https://www.thuisarts.nl/veel-te-vroeg-bevallen" target="_blank">Veel te vroeg bevallen</a>. Of stel ze aan je arts.</p>
            <h2>Wil je meer informatie of steun?</h2>
            <ul>
              <li><a href="https://www.care4neo.nl/ondersteuning" target="_blank">Care4Neo</a>: de patiëntenvereniging voor ouders van zieke en te vroeg geboren baby’s. Je vindt er meer informatie en je kunt contact hebben met ouders die hetzelfde hebben meegemaakt. Of die een situatie hebben meegemaakt die erop lijkt.</li>
              <li><a href="https://www.stillelevens.nl/" target="_blank">Stille levens</a>: hier vind je meer informatie en steun als je baby waarschijnlijk gaat overlijden, of als je baby is overleden. Je kunt ook contact hebben met ouders die hetzelfde hebben meegemaakt.</li>
            </ul>
          </div>
        `,
      },
    },
  ],
}

export default extremeVroeggeboorte
